import Link from "next/link"
import Svg from "@common/svg"

interface LinkProps {
  link: string
  handleClick?: () => void
  className: string
  text: string
}

interface SuccessMessageProps {
  iconName?: string
  title: string
  paragraphs: string[]
  buttons: LinkProps[]
}

const SuccessMessage = ({
  iconName = "check",
  title,
  paragraphs,
  buttons,
}: SuccessMessageProps) => (
  <div className="flex mx-auto max-w-md flex-col items-center gap-2 justify-center">
    <span className="flex justify-center rounded-full p-2 bg-primary animate-loadFadeUp">
      <Svg
        tooltipContent={undefined}
        name={iconName}
        classes="w-16 h-16 text-white "
        strokeWidth={2}
      />
    </span>
    <h2 className="header-2 py-2">{title}</h2>
    {paragraphs.map((paragraph, index) => (
      <p key={index} className="text-center">
        {paragraph}
      </p>
    ))}
    <div className="flex gap-4 py-4">
      {buttons.map(({ link, handleClick, className, text }, index) => (
        <Link href={link} onClick={handleClick} className={className} key={index}>
          {text}
        </Link>
      ))}
    </div>
  </div>
)

export default SuccessMessage
